import {memo} from 'react'
import '../../utils/sentry' // <== this is where the magic append

export const Sentry = memo(() => {
  return null
})
